import { Middleware } from '@reduxjs/toolkit';

const serverTimingMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  const result = next(action);

  if (import.meta.env.DEV) {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if ('serverTiming' in entry) {
            console.log('Server Timing Data:', entry.serverTiming);
          }
        }
      });

      observer.observe({ type: 'navigation', buffered: true });
    } else {
      console.warn('PerformanceObserver is not supported in this browser.');
    }
  }

  return result;
};

export default serverTimingMiddleware;
